import { render } from "./InlineQuestion.vue?vue&type=template&id=3f67f4db&ts=true"
import script from "./InlineQuestion.vue?vue&type=script&lang=ts"
export * from "./InlineQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__